// Definitions

(function() {

  if (typeof window.SITE === "undefined") {
    window.SITE = {};
  }


SITE.homepageAnimation = function() {
  var windowWidth = window.innerWidth;
  var slices = document.querySelectorAll('.hp-slice');
  for (var i = 0; i < slices.length; i++) {

    var slice = slices[i];
    $(slice).hover(
      function() {

        $(this).siblings().css("pointer-events","none");

      },
      function() {
        removeHover($(this))
      }
    )
  }



  function removeHover(elem) {
    setTimeout(
      function()
      {
        var siblings = $(elem).siblings()
        for (var i=0; i < siblings.length; i++) {
          sibling = siblings[i];
          sibling.style.pointerEvents = 'auto';
        }

    }, 2);
  }
}

  SITE.enableHeaderSlider = function() {
    var $slider = $('.page__header-slider');

    $('.page__header-slider').on('init', function(event,slick){
      var controller = new ScrollMagic.Controller();
      var timeline2 = new TimelineMax()
        .from('.slick-arrow', 1, {opacity:'.8'})
        .to('.slick-arrow', 1, {opacity: '0'});

      new ScrollMagic.Scene({triggerElement:"#slider-parent", reverse:true, duration: '100%'})
        .setTween(timeline2)
        .addTo(controller)

});

    if ($slider.length > 0) {
      $slider.slick({
        dots: false,
        arrows: true,
        adaptiveHeight: true,
        autoplay: false,
        nextArrow: '<button id="btn-1" type="button" class="slick-next"><svg class="icon arrow-thin-right"><use xlink:href="/wp-content/themes/sobrato/public/images/icons.svg#arrow-thin-right"></use></svg></button>',
        prevArrow: '<button id="btn-2" type="button" class="slick-prev"><svg class="icon arrow-thin-left"><use xlink:href="/wp-content/themes/sobrato/public/images/icons.svg#arrow-thin-left"></use></svg></button>',
        slidesToShow: 1,
        slidesToScroll: 1
      });
    }



    var $singleSlide = $('.single-slide');
    if ($singleSlide) {
      $singleSlide.detach();
      $(".slick-list").append($singleSlide);
    }




  }

  SITE.enableGivingSlider = function() {

    var $slider = $(".giving__columns");
    if ($slider.length > 0) {
      $slider.slick({
        dots: true,
        arrows: false,
        autoplay: true,
        speed: 500,
        slidesToShow: 1
      });
    }
  }


  SITE.enableWorkSlider = function() {
    var $slider = $('.page__work');

    if ($slider.length > 0) {
      var $sliderCanvas = $slider.find('.slider__canvas');
      var $sliderText = $slider.find('.slider__text');

      $sliderCanvas.slick({
        slidesToShow: 1,
        autoplay: false,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        dots: true,
        speed: 500

      });

      var dots = document.querySelectorAll(".slick-dots li");

      for (var i = 0; i < dots.length; i++) {
        var dot = dots[i]
        dot.firstElementChild.setAttribute("data-index", i);

      }

//Change the Activte States on Slide Change Events.
var myWork = document.querySelectorAll('.slider__nav .work');

      $(".slider__canvas").on('afterChange', function(event, slick, currentSlide, nextSlide) {
        var elSlide = $(slick.$slides[currentSlide]);
        var dataIndex = elSlide.data('slick-index');

        $('.work').siblings().removeClass('active');
        $sliderText.find('.work[data-index="' + dataIndex + '"]').addClass('active');
        myWork[dataIndex].classList.add('active');

      });


      $('.slider__nav  .work').click(function() {
        var index = parseInt($(this).attr('data-index'));
        $sliderCanvas.slick('slickGoTo', index);

        $(this).siblings().removeClass('active');
        $(this).addClass('active');

        $sliderText.find('.work').removeClass('active');
        $sliderText.find('.work[data-index="' + index + '"]').addClass('active');

      });

      $('.slick-dots li button').click(function() {
        var index = parseInt($(this).attr('data-index'));
        $sliderCanvas.slick('slickGoTo', index);

        $(this).siblings().removeClass('active');
        $(this).addClass('active');

        $sliderText.find('.work').removeClass('active');
        $sliderText.find('.work[data-index="' + index + '"]').addClass('active');

      });
    }
  }
})();


// Invocations

$(function() {

  SITE.enableHeaderSlider();

  SITE.enableWorkSlider();

  SITE.enableGivingSlider();

  // SITE.homepageAnimation();

});


function responsiveGivingSlider() {
  if (window.innerWidth < 768) {
    if (!$('.giving__columns').hasClass('slick-initialized')) {
      SITE.enableGivingSlider();
    }

  } else {
    if ($('.giving__columns').hasClass('slick-initialized')) {
      $('.giving__columns').slick('unslick');
    }
  }
};

$(window).resize(function(e) {
  responsiveGivingSlider();
})

$(document).ready(function(e) {
  responsiveGivingSlider();
})

$(document).ready(function(e) {
  $('.c-accordion__title:last').css('border-bottom', '1px solid #979797');
})
